enum colors{
    "ACTIVE" = "#1890FF",
    "NON_ACTIVE" = "#A7B8C7"
}
export default colors